export default "__VITE_ASSET__DsJNhW$d__"